import { render } from "./vshoppluswecomadd.vue?vue&type=template&id=4d3bcbcc&scoped=true"
import script from "./vshoppluswecomadd.vue?vue&type=script&lang=js"
export * from "./vshoppluswecomadd.vue?vue&type=script&lang=js"

import "./vshoppluswecomadd.vue?vue&type=style&index=0&id=4d3bcbcc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3bcbcc"]])

export default __exports__